import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./chargedetails.module.css";
import { FaDownload, FaFilter } from "react-icons/fa";
import { getChargeDetails } from "../../../Services/APIrequests";
import { IoMdLock } from "react-icons/io";
import { FaRupeeSign } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { PiArrowBendDownRightBold } from "react-icons/pi";

function ChargeDetails({ isSubScribe, chargeDetails ,refreshLoading}) {
    const [currency, setCurrency] = useState("Crore");
    const [chargeData, setChargeData] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterHolders, setFilterHolders] = useState([]);
    const [availableStatuses, setAvailableStatuses] = useState([]);
    const [availableHolders, setAvailableHolders] = useState([]);
    const [availableChargeIds, setAvailableChargeIds] = useState([]);
    const [filterChargeIds, setFilterChargeIds] = useState([]);
    const [openChargeDropdown, setOpenChargeDropdown] = useState(false);
    const [activeTooltip, setActiveTooltip] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            if (activeTooltip) {
                setActiveTooltip(null); // close tooltip when scrolling
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll); // cleanup
        };
    }, [activeTooltip]);

    const { cin } = useParams();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await getChargeDetails(cin);
                if (response.data && response.data.chargeDetails) {
                    setChargeData(response.data.chargeDetails);
                    setAvailableStatuses([
                        ...new Set(
                            response.data.chargeDetails.map(
                                (item) => item.status
                            )
                        ),
                    ]);
                    setAvailableHolders([
                        ...new Set(
                            response.data.chargeDetails.map(
                                (item) => item.charge_order_name
                            )
                        ),
                    ]);
                    setAvailableChargeIds([
                        ...new Set(
                            response.data.chargeDetails.map(
                                (item) => item.charge_id
                            )
                        ),
                    ]);
                }
            } catch (error) {
                console.error(
                    error.response?.data?.message || "Something went wrong"
                );
            }
        }
        if(refreshLoading==false) {
            fetchData();
        }
    }, [cin]);

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case "Modification":
                return { color: "#F3B901" };
            case "Satisfaction":
                return { color: "#008000" };
            case "Creation":
                return { color: "#808080" };
            default:
                return {};
        }
    };

    const formatValue = (value) => (value === "NA" ? "-" : value);

    const handleFilterChange = (e, value, type) => {
        if (type === "status") {
            if (e.target.checked) {
                setFilterStatus((prev) => [...prev, value]);
            } else {
                setFilterStatus((prev) =>
                    prev.filter((item) => item !== value)
                );
            }
        } else if (type === "holder") {
            if (e.target.checked) {
                setFilterHolders((prev) => [...prev, value]);
            } else {
                setFilterHolders((prev) =>
                    prev.filter((item) => item !== value)
                );
            }
        }
    };

    // handle charge id filter changes
    const handleChargeIdFilterChange = (e, value) => {
        if (e.target.checked) {
            setFilterChargeIds((prev) => [...prev, value]);
        } else {
            setFilterChargeIds((prev) => prev.filter((item) => item !== value));
        }
    };

    const filteredChargeData = chargeData.filter((detail) => {
        const matchesStatus =
            filterStatus.length === 0 || filterStatus.includes(detail.status);
        const matchesHolder =
            filterHolders.length === 0 ||
            filterHolders.includes(detail.charge_order_name);
        const matchesChargeId =
            filterChargeIds.length === 0 ||
            filterChargeIds.includes(detail.charge_id);
        return matchesStatus && matchesHolder && matchesChargeId;
    });

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    const toggleTooltip = (type) => {
        if (activeTooltip === type) {
            setActiveTooltip(null);
        } else {
            setActiveTooltip(type);
        }
    };

    const convertValue = (value) => {
        switch (currency) {
            case "Lakh":
                return value * 100;
            case "Million":
                return value * 10;
            case "INR":
                return value * 10000000;
            case "Crore":
            default:
                return value;
        }
    };
    console.log(filteredChargeData);
    return (
        <div className={styles.chargedetailsContainer}>
            <div className={styles.chargedetailsHeader}>
                <div className={styles.chargedetailsHeaderName}>
                    <div
                        className={styles.chargedetailsHeaderinside}
                        style={{ display: "flex", justifyContent: "center" }}>
                        <div>
                            <span>Charge Details</span>
                        </div>

                        {isSubScribe && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}>
                                {/* Rupee Icon */}
                                {filteredChargeData.length > 0 && (
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "var(--PrimaryColor)",
                                            display: "flex",
                                            alignItems: "center",
                                        }}>
                                        <FaRupeeSign />
                                    </span>
                                )}

                                {/* Currency Select */}
                                {filteredChargeData.length > 0 && (
                                    <div>
                                        <select
                                            value={currency}
                                            onChange={(e) =>
                                                setCurrency(e.target.value)
                                            }
                                            style={{
                                                padding: "6px 10px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                fontSize: "14px",
                                                outline: "none",
                                                cursor: "pointer",
                                                minWidth: "120px",
                                            }}>
                                            <option value="Crore">Crore</option>
                                            <option value="Lakh">Lakh</option>
                                            <option value="INR">INR</option>
                                            <option value="" disabled>
                                                --------
                                            </option>
                                            <option value="Million">
                                                Million
                                            </option>
                                        </select>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {isSubScribe && (
                    <div className={styles.chargedetailsdownload}>
                        <button className={styles.chargedetailsdownloadbutton}>
                            <FaDownload /> DOWNLOAD
                        </button>
                    </div>
                )}
            </div>

            <div>
                {isSubScribe ? (
                    <div>
                        <div className={styles.filterIconContainer}>
                            {/* Tooltip for Status Filter */}
                            {activeTooltip === "status" && (
                                <div className={styles.tooltip1}>
                                    <div className={styles.filterOptions}>
                                        {availableStatuses.map((status) => (
                                            <label key={status}>
                                                <input
                                                    type="checkbox"
                                                    checked={filterStatus.includes(
                                                        status
                                                    )}
                                                    onChange={(e) =>
                                                        handleFilterChange(
                                                            e,
                                                            status,
                                                            "status"
                                                        )
                                                    }
                                                />
                                                {status}
                                            </label>
                                        ))}
                                        <button
                                            className={
                                                styles.closeTooltipButton
                                            }
                                            onClick={() =>
                                                setActiveTooltip(null)
                                            } // Close tooltip
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                            {/* Charge Id multi-select dropdown button */}
                            <div style={{ marginTop: 8 }}>
                                {/*  <button
                                    onClick={() =>
                                        setOpenChargeDropdown((s) => !s)
                                    }
                                    style={{
                                        padding: "8px 10px",
                                        borderRadius: 6,
                                        border: "1px solid #ccc",
                                        background: "#fff",
                                        cursor: "pointer",
                                        minWidth: 160,
                                    }}>
                                    Charge Ids
                                    {filterChargeIds.length > 0 && (
                                        <span style={{ marginLeft: 8 }}>
                                            ({filterChargeIds.length})
                                        </span>
                                    )}
                                </button> */}

                                {openChargeDropdown && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            zIndex: 9999,
                                            background: "#fff",
                                            border: "1px solid #ddd",
                                            boxShadow:
                                                "0 6px 18px rgba(0,0,0,0.08)",
                                            padding: 12,
                                            marginTop: 8,
                                            width: 260,
                                            maxHeight: 220,
                                            overflowY: "auto",
                                        }}>
                                        <div style={{ marginBottom: 8 }}>
                                            <strong>Select Charge Ids</strong>
                                        </div>
                                        {availableChargeIds.length === 0 ? (
                                            <div>No charge ids</div>
                                        ) : (
                                            availableChargeIds.map((cid) => (
                                                <label
                                                    key={cid}
                                                    style={{
                                                        display: "block",
                                                        marginBottom: 6,
                                                        cursor: "pointer",
                                                    }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={filterChargeIds.includes(
                                                            cid
                                                        )}
                                                        onChange={(e) =>
                                                            handleChargeIdFilterChange(
                                                                e,
                                                                cid
                                                            )
                                                        }
                                                        style={{
                                                            marginRight: 8,
                                                        }}
                                                    />
                                                    {cid}
                                                </label>
                                            ))
                                        )}

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 8,
                                                marginTop: 8,
                                                justifyContent: "flex-end",
                                            }}>
                                            <button
                                                onClick={() => {
                                                    setFilterChargeIds([]);
                                                }}
                                                style={{
                                                    padding: "6px 10px",
                                                    borderRadius: 4,
                                                    border: "1px solid #ccc",
                                                    background: "#fff",
                                                    cursor: "pointer",
                                                }}>
                                                Clear
                                            </button>
                                            <button
                                                onClick={() =>
                                                    setOpenChargeDropdown(false)
                                                }
                                                style={{
                                                    padding: "6px 10px",
                                                    borderRadius: 4,
                                                    border: "none",
                                                    background:
                                                        "var(--PrimaryColor)",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                }}>
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Tooltip for Holder Filter */}
                            {activeTooltip === "holder" && (
                                <div className={styles.tooltip2}>
                                    <div className={styles.filterOptions}>
                                        <div
                                            style={{
                                                maxHeight: "180px",
                                                overflowY: "auto",
                                                paddingRight: "4px",
                                            }}>
                                            {availableHolders.map((holder) => (
                                                <label
                                                    key={holder}
                                                    style={{
                                                        display: "block",
                                                        marginBottom: "6px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={filterHolders.includes(
                                                            holder
                                                        )}
                                                        onChange={(e) =>
                                                            handleFilterChange(
                                                                e,
                                                                holder,
                                                                "holder"
                                                            )
                                                        }
                                                        style={{
                                                            marginRight: "6px",
                                                        }}
                                                    />
                                                    {holder}
                                                </label>
                                            ))}
                                        </div>
                                        <button
                                            className={
                                                styles.closeTooltipButton
                                            }
                                            onClick={() =>
                                                setActiveTooltip(null)
                                            }
                                            style={{
                                                marginTop: "8px",
                                                padding: "4px 10px",
                                                fontSize: "13px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                background:
                                                    "var(--PrimaryColor)",
                                                color: "#fff",
                                                cursor: "pointer",
                                            }}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                            {/* Tooltip for Charge ID Filter */}
                            {activeTooltip === "chargeId" && (
                                <div className={styles.tooltip3}>
                                    <div className={styles.filterOptions}>
                                        <div
                                            style={{
                                                maxHeight: "180px",
                                                overflowY: "auto",
                                                paddingRight: "4px",
                                            }}>
                                            {availableChargeIds.map((cid) => (
                                                <label
                                                    key={cid}
                                                    style={{
                                                        display: "block",
                                                        marginBottom: "6px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={filterChargeIds.includes(
                                                            cid
                                                        )}
                                                        onChange={(e) =>
                                                            handleChargeIdFilterChange(
                                                                e,
                                                                cid
                                                            )
                                                        }
                                                        style={{
                                                            marginRight: "6px",
                                                        }}
                                                    />
                                                    {cid}
                                                </label>
                                            ))}
                                        </div>
                                        <button
                                            className={
                                                styles.closeTooltipButton
                                            }
                                            onClick={() =>
                                                setActiveTooltip(null)
                                            }
                                            style={{
                                                marginTop: "8px",
                                                padding: "4px 10px",
                                                fontSize: "13px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                background:
                                                    "var(--PrimaryColor)",
                                                color: "#fff",
                                                cursor: "pointer",
                                            }}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={styles.table_subcontainer}>
                            <table className={styles.commantable}>
                                <thead>
                                    <tr className={styles.tableHeaderRow}>
                                        <th className={styles.tableHeader}>
                                            Sr.No
                                        </th>
                                        <th className={styles.tableHeader}>
                                            <div
                                                className={styles.tableHeader1}>
                                                <span>Charge Id</span>
                                                <span>
                                                    {availableChargeIds.length >
                                                        0 && (
                                                        <FaFilter
                                                            className={
                                                                styles.filterIcon
                                                            }
                                                            onClick={() =>
                                                                toggleTooltip(
                                                                    "chargeId"
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        </th>
                                        <th className={styles.tableHeader}>
                                            SRN
                                        </th>
                                        <th className={styles.tableHeader}>
                                            <div
                                                className={styles.tableHeader1}>
                                                <span>Status</span>

                                                <span>
                                                    {availableStatuses.length >
                                                        0 && (
                                                        <FaFilter
                                                            className={
                                                                styles.filterIcon
                                                            }
                                                            onClick={() =>
                                                                toggleTooltip(
                                                                    "status"
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        </th>
                                        <th className={styles.tableHeader}>
                                            {" "}
                                            {filterStatus.length == 0
                                                ? "Date of Creation / Date of Satisfaction / Date of modification"
                                                : `${filterStatus
                                                      .map(
                                                          (item) =>
                                                              `Date of ${item}`
                                                      )
                                                      .join("/")} `}
                                        </th>

                                        <th className={styles.tableHeader}>
                                            <div
                                                className={styles.tableHeader1}>
                                                <span>Charge Holder</span>
                                                <span>
                                                    {availableHolders.length >
                                                        0 && (
                                                        <FaFilter
                                                            className={
                                                                styles.filterIcon
                                                            }
                                                            onClick={() =>
                                                                toggleTooltip(
                                                                    "holder"
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Asset Holder
                                        </th>
                                        {/* <th className={styles.tableHeader}>Filing Date</th> */}
                                        <th className={styles.tableHeader}>
                                            Category
                                        </th>

                                        <th className={styles.tableHeader}>
                                            Amount
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Rate of interest
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Repayment term (in months)
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Description of the property charged
                                        </th>
                                        <th className={styles.tableHeader}>
                                            Number of charge holder(s)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredChargeData &&
                                    Array.isArray(filteredChargeData) &&
                                    filteredChargeData.length > 0 ? (
                                        filteredChargeData.map(
                                            (detail, index) => (
                                                <React.Fragment key={detail.id}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {detail.charge_id}
                                                        </td>
                                                        <td>{detail?.srn}</td>
                                                        <td
                                                            className={
                                                                styles.leftAlign
                                                            }
                                                            style={getStatusStyle(
                                                                detail.status
                                                            )}>
                                                            <span
                                                                className={
                                                                    styles.chargecreation
                                                                }>
                                                                {" "}
                                                                <button
                                                                    onClick={() =>
                                                                        toggleRow(
                                                                            detail.id
                                                                        )
                                                                    }
                                                                    className={
                                                                        styles.chargecreationbutton
                                                                    }>
                                                                    {expandedRows[
                                                                        detail
                                                                            .id
                                                                    ]
                                                                        ? "-"
                                                                        : "+"}
                                                                </button>
                                                                {detail.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                           {
  detail.status === 'Modification'
    ? detail.dateOfModification
      ? new Date(detail.dateOfModification).toLocaleDateString(
          "en-GB",
          { day: "numeric", month: "short", year: "numeric" }
        )
      : "-"
    : detail.status === 'Satisfaction'
      ? detail.dateOfSatisfaction
        ? new Date(detail.dateOfSatisfaction).toLocaleDateString(
            "en-GB",
            { day: "numeric", month: "short", year: "numeric" }
          )
        : "-"
      : detail.date
        ? new Date(detail.date).toLocaleDateString(
            "en-GB",
            { day: "numeric", month: "short", year: "numeric" }
          )
        : "-"
}
                                                        </td>
                                                        <td>
                                                            {
                                                                detail.charge_order_name
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                detail?.assetHolderName
                                                            }
                                                        </td>
                                                        <td>
                                                            {detail.category}
                                                        </td>
                                                        <td>
                                                            {formatNumber(
                                                                convertValue(
                                                                    detail.amount
                                                                )
                                                            )}
                                                        </td>
                                                        <td>
                                                            {detail.rateofInterest ||
                                                                "-"}{" "}
                                                        </td>
                                                        <td>
                                                            {detail.termsofPayment ||
                                                                "-"}{" "}
                                                        </td>
                                                        <td>
                                                            <div
                                                                className={
                                                                    styles.threeLineText
                                                                }>
                                                                {
                                                                    detail.propertyParticulars
                                                                }
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {
                                                                detail.no_of_holders
                                                            }
                                                        </td>
                                                    </tr>

                                                    {expandedRows[
                                                        detail.id
                                                    ] && (
                                                        <tr>
                                                            <td
                                                                colSpan={
                                                                    3
                                                                }></td>
                                                            <td colSpan={4}>
                                                                {expandedRows[
                                                                    detail.id
                                                                ] && (
                                                                    <div>
                                                                        <div
                                                                            className={
                                                                                styles.referencedoc_main
                                                                            }>
                                                                            <div>
                                                                                Reference
                                                                                Document(s)
                                                                            </div>
                                                                            <div
                                                                                className={
                                                                                    styles.referencedoc_container
                                                                                }>
                                                                                {detail.reference_documents ? (
                                                                                    <>
                                                                                        <div
                                                                                            className={
                                                                                                styles.referencedoc_container
                                                                                            }>
                                                                                            <ul
                                                                                                style={{
                                                                                                    padding: 0,
                                                                                                    margin: 0,
                                                                                                }}>
                                                                                                {detail
                                                                                                    .reference_documents
                                                                                                    .MaiinFileName && (
                                                                                                    <a
                                                                                                        href={
                                                                                                            detail
                                                                                                                .reference_documents
                                                                                                                .fileurl
                                                                                                        }
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        className={
                                                                                                            styles.referencedoc_mainfilename
                                                                                                        }>
                                                                                                        <PiArrowBendDownRightBold />{" "}
                                                                                                        {
                                                                                                            detail
                                                                                                                .reference_documents
                                                                                                                .MaiinFileName
                                                                                                        }
                                                                                                    </a>
                                                                                                )}
                                                                                                {detail
                                                                                                    .reference_documents
                                                                                                    .Attachments &&
                                                                                                detail
                                                                                                    .reference_documents
                                                                                                    .Attachments
                                                                                                    .length >
                                                                                                    0 ? (
                                                                                                    detail.reference_documents.Attachments.map(
                                                                                                        (
                                                                                                            attachment,
                                                                                                            index
                                                                                                        ) => (
                                                                                                            <li
                                                                                                                key={
                                                                                                                    index
                                                                                                                }
                                                                                                                style={{
                                                                                                                    paddingTop:
                                                                                                                        "0.5rem",
                                                                                                                }}
                                                                                                                className={
                                                                                                                    styles.referencedoc_Attachments
                                                                                                                }>
                                                                                                                <IoDocumentTextOutline
                                                                                                                    size={
                                                                                                                        16
                                                                                                                    }
                                                                                                                    style={{
                                                                                                                        marginRight:
                                                                                                                            "8px",
                                                                                                                        color: "#2961EF",
                                                                                                                    }}
                                                                                                                />
                                                                                                                <a
                                                                                                                    href={
                                                                                                                        attachment.fileurl
                                                                                                                    }
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    style={{
                                                                                                                        textDecoration:
                                                                                                                            "none",
                                                                                                                        color: "#2961EF",
                                                                                                                    }}>
                                                                                                                    {
                                                                                                                        attachment.Name
                                                                                                                    }
                                                                                                                </a>
                                                                                                                <button
                                                                                                                    onClick={() => {
                                                                                                                        const link =
                                                                                                                            document.createElement(
                                                                                                                                "a"
                                                                                                                            );
                                                                                                                        link.href =
                                                                                                                            attachment.fileurl;
                                                                                                                        link.download =
                                                                                                                            attachment.Name;
                                                                                                                        link.click();
                                                                                                                    }}
                                                                                                                    title="Download"
                                                                                                                    style={{
                                                                                                                        background:
                                                                                                                            "none",
                                                                                                                        border: "none",
                                                                                                                        cursor: "pointer",
                                                                                                                        color: "#2961EF",
                                                                                                                        marginLeft:
                                                                                                                            "5px",
                                                                                                                        textDecoration:
                                                                                                                            "underline",
                                                                                                                    }}>
                                                                                                                    <FiDownload />
                                                                                                                </button>
                                                                                                            </li>
                                                                                                        )
                                                                                                    )
                                                                                                ) : (
                                                                                                    <span></span>
                                                                                                )}
                                                                                            </ul>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <span>
                                                                                        No
                                                                                        documents
                                                                                        available
                                                                                        for
                                                                                        selected
                                                                                        year
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        {detail?.status !=
                                                                            "Satisfaction" && (
                                                                            <table
                                                                                className={
                                                                                    styles.labelCellcommantable
                                                                                }>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Instrument
                                                                                            Description:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.InstrumentDescription
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Rate
                                                                                            of
                                                                                            Interest:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {
                                                                                                detail.rateofInterest
                                                                                            }

                                                                                            %
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Terms
                                                                                            of
                                                                                            Payment:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.termsofPayment
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Property
                                                                                            Particulars:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.propertyParticulars
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Extent
                                                                                            and
                                                                                            Operation:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.extentandOperation
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Joint
                                                                                            Holding:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.jointHolding
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell
                                                                                            }>
                                                                                            Consortium
                                                                                            Holding:
                                                                                        </td>
                                                                                        <td
                                                                                            className={
                                                                                                styles.labelCell_1
                                                                                            }>
                                                                                            {formatValue(
                                                                                                detail.consortiumHolding
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            )
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="8">
                                                No charge details available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className={styles.subscriptionMessage}>
                        <button className={styles.Subscription_msg}>
                            <IoMdLock /> Subscription required to view data
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChargeDetails;
